import { render, staticRenderFns } from "./TabTeacher.vue?vue&type=template&id=43d8bc4e"
import script from "../../../services/teacher/DetailClassTab/tab-teacher.js?vue&type=script&lang=js&external"
export * from "../../../services/teacher/DetailClassTab/tab-teacher.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports